export default __webpack_public_path__ + "static/logo_white-c929dd6d7d7586fbb8592e86a6b312cc.png";